import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";
import SelectDropdown from "../../../components-react/SelectDropdown";
import { selectToken } from "../../../auth/auth.selector";
import { months } from "../../../common-data/DropdowData";
import { currentMonthNumber, currentYear } from "../../../common-data/Converts";
import { addStaffTarget } from "../../../../redux/reducers/postApiSlice";
import ReactVortoxSpinner from "../../../common-components/ReactVortoxSpinner";

const TargetAssign = ({ closeModal, queryParams, prevData, callFunction }) => {
  const token = useSelector(selectToken);
  const dispatch = useDispatch();

  const { loading } = useSelector((state) => state.postApi);

  const paramsArray = queryParams.slice(1).split("&");
  const paramsObj = {};
  paramsArray.forEach((param) => {
    const [key, value] = param.split("=");
    paramsObj[key] = decodeURIComponent(value);
  });
  const month = paramsObj.month;
  const year = paramsObj.year;
  const userId = paramsObj.user_id;

  const iniFormValues = [
    {
      monthNo: "",
      regularAmount: 0,
      ptAmount: 0,
      addonAmount: 0,
      totalAmount: 0,
    },
  ];
  const [formValues, setFormValues] = useState(iniFormValues);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  const onChangeInput = (e) => {
    const { name, value } = e.target;

    setFormValues((prevs) => ({
      ...prevs,
      [name]: value,
    }));
    setIsSubmit(false);
  };

  const onChangeDropdown = (value, name) => {
    setFormValues((prev) => ({
      ...prev,
      [name]: value,
    }));
    setIsSubmit(false);
  };

  const onSumitForm = (e) => {
    e.preventDefault();

    setFormErrors(validateFormValues(formValues));
    setIsSubmit(true);
  };

  const validateFormValues = (formValues) => {
    let errors = {};

    if (!formValues.monthNo) {
      errors.monthNo = "Month is required!";
    }

    return errors;
  };

  const handleAdd = async (requestBody, TOKEN) => {
    setIsSubmit(false);

    try {
      const actionResult = dispatch(addStaffTarget({ requestBody, TOKEN }));
      const result = await actionResult;

      if (result?.payload?.status) {
        toast.success(result?.payload?.message || "Success!");
        setFormValues(iniFormValues);
        setFormErrors({});
        closeModal();
        callFunction();
      } else {
        const errorMessage = result?.error?.message || result?.payload?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.log("handleAdd ERROR => ", error);
    }
  };

  useEffect(() => {
    if (month) {
      setFormValues((prevs) => ({
        ...prevs,
        monthNo: months.filter((mo) => mo?.value === month)?.[0] || "",
        regularAmount: prevData?.regular ? prevData.regular : 0,
        ptAmount: prevData?.addon_pt ? prevData.addon_pt : 0,
        addonAmount: prevData?.addon ? prevData.addon : 0,
        totalAmount: prevData?.target_value ? prevData.target_value : 0,
      }));
    }
  }, [month, prevData]);

  useEffect(() => {
    const amount =
      parseInt(formValues.regularAmount || 0) +
      parseInt(formValues.addonAmount || 0) +
      parseInt(formValues.ptAmount || 0);

    setFormValues((prevs) => ({
      ...prevs,
      totalAmount: amount || 0,
    }));
  }, [formValues.regularAmount, formValues.addonAmount, formValues.ptAmount]);

  useEffect(() => {
    if (isSubmit && Object.keys(formErrors)?.length === 0) {
      const userData = {
        user_id: userId,
        target_value: formValues.totalAmount,
        year: year,
        month: formValues.monthNo?.value,
        regular: formValues.regularAmount || 0,
        addon_pt: formValues.ptAmount || 0,
        addon: formValues.addonAmount || 0,
      };

      handleAdd(userData, token);
    }
  }, [isSubmit, formErrors]);

  return (
    <>
      <div className="createNewCTOModalContainer form-container">
        <form className="formContainer">
          <div className="formInputsGrid threeGridSystem">
            <div className="formInputBox">
              <label htmlFor="monthNo" className={`formInputLabel `}>
                Month *
              </label>

              <div
                className={`commonWrapper ${
                  formErrors.monthNo ? "formError" : ""
                }`}
              >
                <SelectDropdown
                  options={
                    year === currentYear
                      ? months?.filter(
                          (month) => parseInt(month.value) >= currentMonthNumber
                        )
                      : months
                  }
                  selectedOption={formValues.monthNo}
                  setSelectedOption={(selectedValue) =>
                    onChangeDropdown(selectedValue, "monthNo")
                  }
                  name=""
                />
              </div>
            </div>

            <div className="formInputBox">
              <label htmlFor="regularAmount" className={`formInputLabel `}>
                Regular Membership
              </label>

              <input
                type="number"
                placeholder="Enter Regular Amount"
                className={`formInput ${
                  formErrors?.regularAmount ? "formError" : ""
                }`}
                name="regularAmount"
                value={formValues.regularAmount}
                onChange={onChangeInput}
              />
            </div>

            <div className="formInputBox">
              <label htmlFor="ptAmount" className={`formInputLabel `}>
                Personal Training
              </label>

              <input
                type="number"
                placeholder="Enter PT Amount"
                className={`formInput ${
                  formErrors?.ptAmount ? "formError" : ""
                }`}
                name="ptAmount"
                value={formValues.ptAmount}
                onChange={onChangeInput}
              />
            </div>

            <div className="formInputBox">
              <label htmlFor="addonAmount" className={`formInputLabel `}>
                Addon
              </label>

              <input
                type="number"
                placeholder="Enter Addon Amount"
                className={`formInput ${
                  formErrors?.addonAmount ? "formError" : ""
                }`}
                name="addonAmount"
                value={formValues.addonAmount}
                onChange={onChangeInput}
              />
            </div>

            <div className="formInputBox">
              <label htmlFor="totalAmount" className="formInputLabel">
                Total Target Amount
              </label>

              <input
                type="number"
                className={`formInput ${
                  formErrors?.totalAmount ? "formError" : ""
                }`}
                name="totalAmount"
                placeholder={`🚫 ${formValues.totalAmount || "0"}`}
                disabled
              />
            </div>
          </div>

          <div
            className="formButtons mt30"
            style={{ justifyContent: "flex-end" }}
          >
            <Button className="saveBtn" variant="danger" onClick={onSumitForm}>
              {loading ? <ReactVortoxSpinner /> : "Submit"}
            </Button>
          </div>
        </form>
      </div>
    </>
  );
};

export default TargetAssign;
